import { USER_ROLE } from '../../../services/auth';

const RequestorSection = ({
  register,
  watch,
  errors,
  loadingSupervisors,
  validationErrors
}) => {

  const role = localStorage.getItem(USER_ROLE);
  const showLoadingSupervisor = ['admin', 'branch_admin'].includes(role);
  const isBranchUser = role === 'branch_user';
  const selectedSupervisorId = watch("loading_supervisor_id");
  const isOthersSupervisor = Number(selectedSupervisorId) === -1;

  return (
    <>
      <section>
        <div className="grid md:grid-cols-3 gap-4">
          <div className="flex flex-col">
            <label className="text-xs text-gray-600 mb-1">Requested By</label>
            <input
              {...register("requested_by")}
              type="text"
              className="border rounded p-2 text-sm w-full uppercase"
            />
            {errors.requested_by && (
              <p className="text-red-500 text-sm mt-1">{errors.requested_by[0]}</p>
            )}
          </div>
        </div>
      </section>

      <section>
        <div className="grid md:grid-cols-3 mt-4 gap-4">
          {showLoadingSupervisor && (
            <div className="flex flex-col">
              <label className="text-xs text-gray-600 mb-1">Loading Supervisor</label>
              <select
                {...register("loading_supervisor_id", { valueAsNumber: true })}
                className="border rounded p-2 text-sm w-full uppercase"
              >
                <option value={0}>Select Loading Supervisor</option>
                <option value={-1}>Others</option>
                {loadingSupervisors.map(ls => (
                  <option key={ls.id} value={ls.id}>{ls.name}</option>
                ))}
              </select>
              {errors.loading_supervisor && (
                <p className="text-red-500 text-sm mt-1">{errors.loading_supervisor[0]}</p>
              )}
            </div>
          )}

          <div className="flex flex-col">
            <label className="text-xs text-gray-600 mb-1">Supervisor Name</label>
            <input
              {...register("loading_supervisor_name")}
              type="text"
              className="border rounded p-2 text-sm w-full uppercase disabled:bg-gray-100 disabled:text-gray-400 disabled:border-gray-300 disabled:cursor-not-allowed"
              disabled={isBranchUser || (showLoadingSupervisor && !isOthersSupervisor)}
            />
            {validationErrors.loading_supervisor_name && (
              <p className="text-red-500 text-sm mt-1">{validationErrors.loading_supervisor_name}</p>
            )}
          </div>

          <div className="flex flex-col">
            <label className="text-xs text-gray-600 mb-1">Supervisor Contact</label>
            <input
              {...register("loading_supervisor_contact", {
                onChange: (e) => {
                  e.target.value = e.target.value.replace(/\D/g, '').slice(0, 10);
                }
              })}
              type="text"
              className="border rounded p-2 text-sm w-full uppercase disabled:bg-gray-100 disabled:text-gray-400 disabled:border-gray-300 disabled:cursor-not-allowed"
              disabled={isBranchUser || (showLoadingSupervisor && !isOthersSupervisor)}
            />
            {errors.loading_supervisor_contact && (
              <p className="text-red-500 text-sm mt-1">{errors.loading_supervisor_contact[0]}</p>
            )}
            {validationErrors.loading_supervisor_contact && (
              <p className="text-red-500 text-sm mt-1">{validationErrors.loading_supervisor_contact}</p>
            )}
          </div>
        </div>
      </section>
    </>
  );
};

export default RequestorSection;
